import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";
import {listArtefacts} from '../utils/utilsArtefact';

import * as PD from '../classes/pdStyle';

class ListArtefacts extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Artefacts : null
        };

        this.dsd = new dsd();

    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){

   if (!isEqual(this.props, prevProps)){
       this.setup();
   }

}

loadData(filters){

    this.setState({renderState: "loading"});

    const onLoad = (Artefacts) => {
        this.setState({
            Artefacts: Artefacts,
            renderState: "loaded"
        });
        
        // Call parent's onLoad callback if provided
        if (this.state.onLoad){
            this.state.onLoad(Artefacts.length);
        }
    };

    const onError = (error) => {
        this.setState({
            renderState: "failed",
            errorMessage: error.message || "Failed to load artefacts"
        });
    };

    listArtefacts(this.dsd, filters || {}, onLoad, onError);
}

setup(){

    let StateChange = {
        filters: {},
        columns: {
            owner:true,
            status:true
        },
        renderState: 'loading',
        onLoad: null
    };


    StateChange.filters = getParam('filters', this.props);

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

    this.setState(StateChange);

    this.loadData(StateChange.filters);
        
}



    included(Artefact) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {


        if (this.state.renderState === "failed") {
            return (
                <PD.ErrorBox>
                    A problem has occurred
                </PD.ErrorBox>
            )
        }

        if (this.state.renderState === "loading") {
            return null;
        }

        if (this.state.renderState === "loaded") {
            let arrArtefacts = this.state.Artefacts;
            if (isArray(arrArtefacts)){
                if (arrArtefacts.length > 0 ){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.status &&
                                        <PD.Th>Status</PD.Th>                            
                                    }                                    
                                    <PD.Th>Type</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrArtefacts.map(
                                    (Artefact, pos) => 
                                    {
                                        if (this.included(Artefact)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                

                                            let modelArtefact = null;
                                            if ("type" in Artefact){
                                                if (Artefact.type in this.dsd.model.artefacts){
                                                    modelArtefact = this.dsd.model.artefacts[Artefact.type];
                                                }
                                            }
                                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/artefact/" + Artefact.id} > {Artefact.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                        {this.state.columns.owner &&
                                                            <PD.Td>
                                                                {Artefact.Owner &&
                                                                    Artefact.Owner.organisation}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.status &&
                                                            <PD.Td>
                                                                {Artefact.status}
                                                            </PD.Td>
                                                        }
                                                        <PD.Td>
                                                            {modelArtefact &&
                                                                modelArtefact.label}
                                                        </PD.Td>

                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Artefact.description, 400)}</PD.MdPresent>
                                                        </PD.Td>

                                                    </PD.Tr>

                                                    

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }

        }

        return <div />;

    };    
};
        
export default function ListArtefacts_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListArtefacts {...props} navigation={navigation} location={location} params={params} />;
  }
